import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CancelOrderService } from '../../../cancel-order/services/cancel-order.service';
import { CancelOrder, CancelOrderGarment } from '../../../cancel-order/models/cancel-order.model';
import { ToasterService } from "../../../../common/services/toaster.service";
import { GtrakAuthService } from "../../../authentication/services/gtrak-auth.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';
@Component({
    selector: 'app-customer-cancel-order-page',
    templateUrl: 'customer-cancel-order.page.html',
    styleUrls: [
      './customer-cancel-order.page.scss',
    ]
  })
  export class CustomerCancelOrderPage implements OnInit {

    constructor(
      private router: Router,
      public authService: GtrakAuthService,
      private route: ActivatedRoute,
      private toasterService: ToasterService,
      private cancelOrderService: CancelOrderService,
    ) { }
    customerCode:string="";
    currentDate = new Date();
    cancelOrders: any[] = [];
    totalLossCharge: number = 0;
    loaded: boolean=false;
    requestParams:any;
    isShowData:boolean=false;
    async ngOnInit() {
      
     this.loaded = true;
    }
    public viewChange: boolean = false;

   async loadData(){
      this.loaded = false;
      this.requestParams = new RequestParams();
      await this.cancelOrderService.getSpecialCancelReport(this.customerCode,this.requestParams).then((cancelOrder) => {
      this.cancelOrders = cancelOrder;
       this.totalLossCharge =0;
      });
      for (let i = 0; i < this.cancelOrders.length; i++) {
        let woLossCharge = 0;
        
        const cancelOrderGarments = this.cancelOrders[i] as unknown as CancelOrderGarment[];
        for (let j = 0; j < cancelOrderGarments.length; j++) {
          if(cancelOrderGarments[j].dateCollected === null) {
            woLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            this.totalLossCharge += parseFloat(cancelOrderGarments[j].lossCharge);
            woLossCharge = Math.round(woLossCharge * 100) / 100;
            this.totalLossCharge = Math.round(this.totalLossCharge * 100) / 100;
          }
        }
        this.cancelOrders[i].lossCharge = woLossCharge;
      }

      this.loaded = true;
    }
 getCustomerReport(){
  if(this.customerCode==""){
     this.toasterService.presentToast(
        "danger",
        "Error",
        "Please Enter Customer Code."
      );
    }
    else{
        this.isShowData=true;
        this.loadData();
    }
 }
 changePrinterView(): void {
    this.viewChange = !this.viewChange;
    setTimeout(() => {
      print();
    }, 1000);
  }
   onEnterKey(event: KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      this.getCustomerReport();
    }
  }